goog.provide('el8.app.settings.careTeamSharing');

goog.require('el8.app.settings.reactTab');

el8.app.settings.careTeamSharing = el8.app.settings.reactTab({
  containerId: 'care-team-sharing',
  renderFnName: 'renderCareTeamSharingSettings',
  props: {
    practiceId: el8Globals.PRACTICE_ID
  }
});
